export const shadows = {
  light: {
    none: 'none',
    sm: 'none',
    md: 'none',
    lg: 'none',
    overlay: '0 24px 72px rgba(15, 23, 42, 0.18)',
  },
  dark: {
    none: 'none',
    sm: 'none',
    md: 'none',
    lg: 'none',
    overlay: '0 28px 88px rgba(0, 0, 0, 0.5)',
  },
} as const;

export type ShadowToken = keyof typeof shadows.light;
